export default __webpack_public_path__ + "static/featured-image-7786eef6a2696bbf588787d859f3135c.jpg";